import {getWaitfreeBadge} from '../../../../common/getCommonBadge';
import {BADGE_TYPE_TO_CONTENT_HOME_BADGE_TYPE_MAP} from '../constant';

export function getContentHomeWaitfreeBadgeType(
  waitfreePeriodByMinute?: number | null
) {
  const badgeType = getWaitfreeBadge(waitfreePeriodByMinute);
  return BADGE_TYPE_TO_CONTENT_HOME_BADGE_TYPE_MAP[badgeType];
}
